import { get } from 'lodash';

export class DeclarationForm {
  policy: boolean | undefined;
  summary: boolean | undefined;
  term: boolean | undefined;
  declaration: boolean | undefined;
  ped: boolean | undefined;
  benefit: boolean | undefined;
  completed: boolean | undefined;
  assured:  boolean | undefined;
  understand: boolean | undefined;

  constructor(initial: any) {
    this.policy = get(initial, 'policy', undefined);
    this.summary = get(initial, 'summary', undefined);
    this.term = get(initial, 'term', undefined);
    this.ped =  get(initial, 'ped', undefined);
    this.benefit =  get(initial, 'benefit', undefined);
    this.completed = get(initial, 'completed', undefined);
    this.assured = get(initial, 'assured', undefined);
    this.understand = get(initial, 'understand', undefined);
  }

  get reviewDeclaration(): { text: string, value: string }[]  {
    return [
      { text: 'I have downloaded, fully read and understood the cover page and policy illustration', value: this.getAnswer(this.policy) },
      { text: 'I have downloaded, fully read and understood the product summary', value: this.getAnswer(this.summary) },
      { text: 'I have downloaded, fully read and understood the policy terms and conditions', value: this.getAnswer(this.term)},
      { text: 'I have downloaded, fully read and agreed to the statements described in this declaration document', value: this.getAnswer(this.ped)},
      { text: 'I am not a Politically Exposed Person (PEP) or a family member/close associate of a PEP', value: this.getAnswer(this.assured )},
      { text: 'There is no beneficial ownership arrangement under this application', value: this.getAnswer(this.benefit) },
      { text: 'I have completed and disclosed fully and truthfully all the information requested for in this application', value:  this.getAnswer(this.completed)},
      { text: 'I understand that I will receive my policy, any endorsements and communications electronically once they are ready. I understand that I may log on to MySinglife to opt for my preferred document option and may switch between e-documents and printed documents', value:  this.getAnswer(this.understand)},
    ];
  }
  
  getAnswer(input: boolean | undefined) {
    return input ? 'Yes' : 'No';
  }
}

export interface IReadDocs {
  isReadPolicy: boolean;
  isReadProduct: boolean;
  isReadTerms: boolean;
  isReadDeclare: boolean;
}